// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--NdAzz","logo-block":"a10a3f92e9--logo-block--SeUgM","title":"a10a3f92e9--title--tOiv1","title-block":"a10a3f92e9--title-block--A09_U"};